import { Badge } from '@ui';
import { BadgeProps } from '@ui/Badge';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { AllocationAttendance } from '../types';

interface Props {
    attendance?: AllocationAttendance | null;
    size?: BadgeProps['size'];
}

/**
 * Shows whether a booking still needs its attendance confirmed. Renders nothing when the
 * VerifyAttendance effect does not apply — most bookings never carry an attendance at all.
 */
const AttendanceBadge = ({ attendance, size = 'xs' }: Props) => {
    const { t } = useTranslation('space-manager');

    if (!attendance) return null;

    // three states, in the order an admin cares about them: done, missed, still running
    const { label, color }: { label: string; color: BadgeProps['color'] } = attendance.fulfilled
        ? { label: t('attendance.badge.confirmed'), color: 'success' }
        : attendance.expired
          ? { label: t('attendance.badge.overdue'), color: 'error' }
          : {
                label: t('attendance.badge.open', {
                    time: moment(attendance.due_at).format('DD.MM.YY HH:mm')
                }),
                color: 'warning'
            };

    return (
        <Badge flat color={color} size={size} className="tw-whitespace-nowrap">
            {label}
        </Badge>
    );
};

export default AttendanceBadge;
